import {
  FACE_TO_FACE_PACKAGE_SUCCESS,
  FACE_TO_FACE_PACKAGE_FAILURE,
  TOTAL_GET_F2F_PACKAGES,
  FACE2FACE_EDIT_PACKAGE_SUCCESS,
  FACE2FACE_EDIT_PACKAGE_FAILURE,
  DELETED_PACKAGES,
  FACE_TO_FACE_DELTE_PACKAGE_FAILURE,
  FACE_TO_FACE_DELTE_PACKAGE_SUCCESS,
  CREATE_PACKAGES,
  FACE_2_FACE_CREATE_PACKAGE_SUCESS,
  FACE_2_FACE_CREATE_PACKAGE_FAILURE,
  FACE2FACE_EDIT_PACKAGE_START,
  FACE_2FACE_PACKGE_FOR_USER,
  FACE_2FACE_PACKGE_FOR_USER_SUCCESS,
  FACE_2FACE_PACKGE_FOR_USER_FAILURE,
  FACE_TO_FACE_PACKAGE_DISCOUNT,
  FACE_TO_FACE_PACKAGE_DISCOUNT_SUCCESS,
  FACE_TO_FACE_PACKAGE_DISCOUNT_FAILURE,
  SHOW_FACE2FACE_PACKAGE_SELECTION,
  HIDE_FACE2FACE_PACKAGE_SELECTION
} from "../actions/ActionConstant";

export const initialState = {
  packages: {
    data: {},
    loading: false,
    error: false,
  },
  edit_package: {
    data: {},
    loading: false,
    error: false,
  },
  created_package: {
    data: {},
    loading: false,
    error: false,
  },
  deleted_packages: {
    data: {},
    loading: false,
    error: false,
  },
  per_user_package: {
    data: {},
    loading: true,
    error: false,
  },
  get_packages_discount: {
    data: {},
    loading: true,
    error: false
  },
  package_selection: {
    data: {},
    show: false
  }

};



const Face2Fac2ePackageReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOTAL_GET_F2F_PACKAGES:
      return {
        ...state,
        packages: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FACE_TO_FACE_PACKAGE_SUCCESS:
      return {
        ...state,
        packages: {
          data: action,
          loading: false,
          error: false,
        },
      };
    case FACE_TO_FACE_PACKAGE_FAILURE:
      return {
        ...state,
        packages: {
          data: action.data,
          loading: false,
          error: true,
        },
      };


      case FACE2FACE_EDIT_PACKAGE_START:
        return {
          ...state,
          edit_package: {
            data: {},
            loading: true,
            error: false,
          },
        };
    case FACE2FACE_EDIT_PACKAGE_SUCCESS:
      return {
        ...state,
        get_edit_packages: {
          data: {},
          loading: false,
          error: false,
          inputData: action.data,
        },
      };
    case FACE2FACE_EDIT_PACKAGE_FAILURE:
      return {
        ...state,
        get_edit_packages: {
          data: action.data,
          loading: false,
          error: true,
        },
      };
    


      case CREATE_PACKAGES:
        return {
          ...state,
          created_package: {
            data: {},
            loading: true,
            error: false,
          },
        };
    case FACE_2_FACE_CREATE_PACKAGE_SUCESS:
      return {
        ...state,
        created_package: {
          data: action.data,
          loading: false,
          error: false,
          inputData: action.data,
        },
      };
    case FACE_2_FACE_CREATE_PACKAGE_FAILURE:
      return {
        ...state,
        created_package: {
          data: {},
          loading: false,
          error: action.error,
        },
      };
    



      case DELETED_PACKAGES:
        return {
          ...state,
          deleted_packages: {
            data: {},
            loading: true,
            error: false,
          },
        };
          case FACE_TO_FACE_DELTE_PACKAGE_FAILURE:
        return {
          ...state,
          get_edit_packages: {
            data: action.data,
            loading: false,
            error: true,
          },
        };
        case FACE_TO_FACE_DELTE_PACKAGE_SUCCESS:
      return {
        ...state,
        get_edit_packages: {
          data: action.data,
          loading: false,
          error: false,
        },
      };



      case FACE_2FACE_PACKGE_FOR_USER:
        return {
          ...state,
          per_user_package: {
            data: {},
            loading: true,
            error: false,
          },
        };
          case FACE_2FACE_PACKGE_FOR_USER_SUCCESS:
        return {
          ...state,
          per_user_package: {
            data: action.data,
            loading: false,
            error: true,
          },
        };
        case FACE_2FACE_PACKGE_FOR_USER_FAILURE:
      return {
        ...state,
        per_user_package: {
          data: action.data,
          loading: false,
          error: false,
        },
      };


      case FACE_TO_FACE_PACKAGE_DISCOUNT:
        return {
          ...state,
          get_packages_discount: {
            data: {},
            loading: true,
            error: false,
          },
        };
      case FACE_TO_FACE_PACKAGE_DISCOUNT_SUCCESS:
        return {
          ...state,
          get_packages_discount: {
            data: action,
            loading: false,
            error: false,
          },
        };
      case FACE_TO_FACE_PACKAGE_DISCOUNT_FAILURE:
        return {
          ...state,
          get_packages_discount: {
            data: action.data,
            loading: false,
            error: true,
          },
        };
  
      case SHOW_FACE2FACE_PACKAGE_SELECTION:
        return {
          ...state,
          package_selection: {
            data: action.data,
            show: true
          }
        }

      case HIDE_FACE2FACE_PACKAGE_SELECTION:
        return {
          ...state,
          package_selection: {
            data: {},
            show: false
          }
        }


    default:
      return state;

  };
}

export default Face2Fac2ePackageReducer;
